var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"rowView thanks"},[_c('h3',[_vm._v(_vm._s(_vm.sendResponse))]),_c('p',[_vm._v("\n"+_vm._s(_vm.sendResponseText)+"\n      ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }